import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order__content__shop"
}
const _hoisted_2 = { class: "selected-restaurant" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "shop-name" }
const _hoisted_5 = { class: "dining-type" }
const _hoisted_6 = {
  key: 1,
  class: "dropdown"
}
const _hoisted_7 = {
  key: 0,
  class: "order-note"
}
const _hoisted_8 = { class: "order-note__note" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-cancel" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

import {CartStore} from '@/stores/cart';
import {ShopStore} from '@/stores/shop';
import {DropdownItem} from '@/types';
import {OrderType} from '@/enums';
import {useI18n} from 'vue-i18n';
import DropdownComponent from '@/components/DropdownComponent.vue';

interface Props {
    onOrderTypeChanged?: (orderType: OrderType) => void | null |undefined;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderShopInfo',
  props: {
    onOrderTypeChanged: { type: Function }
  },
  setup(__props: any) {

const props = __props as {
    onOrderTypeChanged?: (orderType: OrderType) => void | null |undefined;
};


/* imports */


const {t} = useI18n();
const cartStore = CartStore();
const shopStore = ShopStore();

const diningTypes: DropdownItem[] = [];
cartStore.state.settings.orderTypes.forEach((orderType: OrderType) => {
    const key = orderType.charAt(0).toLowerCase() + orderType.slice(1);
    diningTypes.push({
        label: t('label.' + key),
        value: orderType,
    });
});

const updateDiningType = (diningType: OrderType) => {
    cartStore.setOrderType(diningType);

    if (diningType === OrderType.TakeAway) {
        cartStore.setNote(null);
    }
    
    if(props.onOrderTypeChanged){
        props.onOrderTypeChanged(diningType);
    }

};

const clearNote = () => {
    cartStore.setNote(null);
}

return (_ctx: any,_cache: any) => {
  return (_unref(shopStore).shop)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('order.selectedRestaurant')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(shopStore).shop.description), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (diningTypes.length > 1)
            ? (_openBlock(), _createBlock(DropdownComponent, {
                key: 0,
                label: _unref(t)('label.'+_unref(cartStore).state.orderType),
                items: diningTypes,
                onOnChanged: updateDiningType
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (diningTypes.length == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(diningTypes[0].label), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(cartStore).state.note)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('order.note')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(_unref(cartStore).state.note) + " ", 1),
                _createElementVNode("button", { onClick: clearNote }, _hoisted_10)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})